export default "__VITE_ASSET__1c134ee2__"